import React from 'react'
import styles from '../../ssnLock.module.css'
import { ISsnAuditRecord } from '../../../../../../../Models/applicationModels'
import { formatUTCDateTime } from '../../../../../../../utils/formatUTCDate'

export const UnlockedThroughSsnTitle = ({ selfSsnLockedDetails }: { selfSsnLockedDetails?: ISsnAuditRecord }) => {
    const unlockedOnFormatted = selfSsnLockedDetails?.unlockedOn ? formatUTCDateTime(selfSsnLockedDetails?.unlockedOn,false, true) : "-"
    return (
        <div className={styles.unlockedContainer}>
            <p className={styles.title}>Identity Unlocked</p>
            <ul className={styles.description}>
                <li className={styles.descriptionKey}><span className={styles.descriptionKeyLabel}>Unlocked by:</span> {selfSsnLockedDetails?.unlockedBy ?? "-"}</li>
                <li className={styles.descriptionKey}><span className={styles.descriptionKeyLabel}>Unlocked at:</span> {unlockedOnFormatted}</li>
                {
                    selfSsnLockedDetails?.remarks && (
                        <li className={styles.descriptionKey}><span className={styles.descriptionKeyLabel}>Reason:</span> {selfSsnLockedDetails?.remarks}</li>
                    )
                }
            </ul>
        </div>
    )
}
